export const GET_TRANSACTIONFEE_INFO_LOADING = 'REDUX_SAGA_GET_TRANSACTIONFEE_INFO_LOADING';
export const TRANSACTIONFEE_DATA_SUCCESS = 'REDUX_SAGA_TRANSACTIONFEE_DATA_SUCCESS';
export const TRANSACTIONFEE_DATA_ERROR = 'REDUX_SAGA_TRANSACTIONFEE_DATA_ERROR';
export const TRANSACTIONFEE_DATA_RESET = 'REDUX_SAGA_TRANSACTIONFEE_DATA_RESET';

export const actionGetTransactionFee = (dispatch, productId, productType) => {
    dispatch({
        type: GET_TRANSACTIONFEE_INFO_LOADING,
        payload: { productId: productId, productType: productType }
    })
};

export const actionResetTransactionFee = (dispatch) => {
    dispatch({ type: TRANSACTIONFEE_DATA_RESET })
};